```vue
<template>
  <div id="ndaylive_event">

    <!-----------------------------------------main------------------------------------->
    <div class="ndaylive_event_main">

      <!-- 배경 PNG -->
      <img
        class="ndaylive_event_main_img"
        src="../assets/img/ndaylive_event/ndaylive_main.png"
        alt=""
      >

      <!-- 비디오 -->
      <div class="ndaylive_event_main_video_div">
        <video
          class="ndaylive_event_video"
          autoplay
          muted
          loop
          playsinline
          controls
        >
          <source
            src="../assets/img/ndaylive_event/livevideo.mp4"
            type="video/mp4"
          >
        </video>
      </div>

    </div>


    <!-----------------------------------------sec_2------------------------------------->
    <div class="ndaylive_event_sec2">

      <img
        src="../assets/img/ndaylive_event/text.png"
        alt=""
      class="mobile_small_bsu">

      <div
        class="ndaylive_sec2_box"
        style="margin-top:50px"
      >
        <img
          src="../assets/img/ndaylive_event/box1.png"
          alt=""
        >
      </div>

      <div class="ndaylive_sec2_box">
        <img
          src="../assets/img/ndaylive_event/box2.png"
          alt=""
        >
      </div>

      <div class="ndaylive_sec2_box">
        <img
          src="../assets/img/ndaylive_event/box3.png"
          alt=""
        >
      </div>

    </div>


    <!-----------------------------------------sec_3------------------------------------->
    <img
      src="../assets/img/ndaylive_event/sec3_line.png"
      alt=""
      style="text-align:center; width:100%;"
      class="ndaylive_event_line_img"
    >

    <img
      src="../assets/img/ndaylive_event/text2.png"
      alt=""
      style="text-align:center; margin:30px auto 0 auto; display:block;"
    class="mobile_small_bsu">

    <div class="ndaylive_event_sec3">

      <div
        class="ndaylive_sec3_slide_wrap"
        ref="slider"
        @mousedown="startDrag"
        @mousemove="onDrag"
        @mouseup="stopDrag"
        @mouseleave="stopDrag"
      >

        <!-- 1 -->
        <div
          class="ndaylive_sec3_box"
          :class="{ locked: !isOpen1 }"
        >
          <img
            src="../assets/img/ndaylive_event/sec_3_box1.png"
            alt=""
          >

          <div
            v-if="!isOpen1"
            class="coming_soon_overlay"
          >
            COMING SOON
          </div>
        </div>

        <!-- 2 -->
        <div
          class="ndaylive_sec3_box"
          :class="{ locked: !isOpen2 }"
        >
          <img
            src="../assets/img/ndaylive_event/sec_3_box2.png"
            alt=""
          >

          <div
            v-if="!isOpen2"
            class="coming_soon_overlay"
          style="text-align: center;">
          6/11 삿포로 <br>
            COMING SOON
          </div>
        </div>

        <!-- 3 -->
        <div
          class="ndaylive_sec3_box"
          :class="{ locked: !isOpen3 }"
        >
          <img
            src="../assets/img/ndaylive_event/sec_3_box3.png"
            alt=""
          >

          <div
            v-if="!isOpen3"
            class="coming_soon_overlay"
          style="text-align: center;">
          6/25 오사카 <br>
            COMING SOON
          </div>
        </div>

        <!-- 4 -->
        <div
          class="ndaylive_sec3_box"
          :class="{ locked: !isOpen4 }"
        >
          <img
            src="../assets/img/ndaylive_event/sec_3_box4.png"
            alt=""
          >

          <div
            v-if="!isOpen4"
            class="coming_soon_overlay"
          style="text-align: center;">
          7/9 나고야 <br>
            COMING SOON
          </div>
        </div>

        <!-- 5 -->
        <div
          class="ndaylive_sec3_box"
          :class="{ locked: !isOpen5 }"
        >
          <img
            src="../assets/img/ndaylive_event/sec_3_box5.png"
            alt=""
          >

          <div
            v-if="!isOpen5"
            class="coming_soon_overlay"
          style="text-align: center;">
          7/23 삿포로 <br>
            COMING SOON
          </div>
        </div>

        <!-- 6 -->
        <div
          class="ndaylive_sec3_box"
          :class="{ locked: !isOpen6 }"
        >
          <img
            src="../assets/img/ndaylive_event/sec_3_box1.png"
            alt=""
          >

          <div
            v-if="!isOpen6"
            class="coming_soon_overlay"
          >
            COMING SOON
          </div>
        </div>

        <!-- 7 -->
        <div
          class="ndaylive_sec3_box"
          :class="{ locked: !isOpen7 }"
        >
          <img
            src="../assets/img/ndaylive_event/sec_3_box2.png"
            alt=""
          >

          <div
            v-if="!isOpen7"
            class="coming_soon_overlay"
          style="text-align: center;">
          6/11 삿포로 <br> 
            COMING SOON
          </div>
        </div>

        <!-- 8 -->
        <div
          class="ndaylive_sec3_box"
          :class="{ locked: !isOpen8 }"
        >
          <img
            src="../assets/img/ndaylive_event/sec_3_box3.png"
            alt=""
          >

          <div
            v-if="!isOpen8"
            class="coming_soon_overlay"
          style="text-align: center;">
          6/25 오사카 <br>
          COMING SOON
          </div>
        </div>

      </div>
    </div>

        <!-----------------------------------------sec_4------------------------------------->
    <img src="../assets/img/ndaylive_event/sec4_line.png" alt="" style="text-align:center; width:100%; margin-top: 30px;" class="ndaylive_event_line_img">
    <div class="ndaylive_event_sec4">
      <img
        src="../assets/img/ndaylive_event/text3.png"
        alt="" style="transition: none; pointer-events: none;"
      class="mobile_small_bsu">

      
        <img
          src="../assets/img/ndaylive_event/sec4_box1.png"
          alt="" style="margin-top:50px"
        >
        <img
          src="../assets/img/ndaylive_event/sec4_box2.png"
          alt="" style="margin-top:30px"
        >
        <img
          src="../assets/img/ndaylive_event/sec4_box3.png"
          alt="" style="margin-top:30px"
        >
        <img
          src="../assets/img/ndaylive_event/sec4_box4.png"
          alt="" style="margin-top:30px"
        >
    </div>
    <div class="ndaylive_event_sec5">
      <div class="ndaylive_event_button">
        <a href="https://shoppinglive.naver.com/channels/144805">알림받기</a>
      </div>
    </div>

  </div>
</template>

<script>
export default {

  data() {
    return {
      isDown: false,
      startX: 0,
      scrollLeft: 0,
      autoSlide: null,
      currentIndex: 0
    }
  },

  computed: {

    isOpen1() {
      return new Date() >= new Date('2026-05-21 00:00:00')
    },

    isOpen2() {
      return new Date() >= new Date('2026-06-11 00:00:00')
    },

    isOpen3() {
      return new Date() >= new Date('2026-06-25 00:00:00')
    },

    isOpen4() {
      return new Date() >= new Date('2026-07-09 00:00:00')
    },

    isOpen5() {
      return new Date() >= new Date('2026-07-23 00:00:00')
    },
    isOpen6() {
      return new Date() >= new Date('2026-05-21 00:00:00')
    },

    isOpen7() {
      return new Date() >= new Date('2026-06-11 00:00:00')
    },

    isOpen8() {
      return new Date() >= new Date('2026-06-25 00:00:00')
    }

  },

  mounted() {
    this.startAutoSlide()
  },

  beforeUnmount() {
    clearInterval(this.autoSlide)
  },

  methods: {

    /* 자동 슬라이드 */
    startAutoSlide() {

      const slider = this.$refs.slider

      this.autoSlide = setInterval(() => {

        const box =
          slider.querySelector('.ndaylive_sec3_box')

        const style =
          window.getComputedStyle(slider)

        const gap =
          parseInt(style.gap)

        const moveWidth =
          box.offsetWidth + gap

        this.currentIndex++

        slider.scrollTo({
          left: moveWidth * this.currentIndex,
          behavior: 'smooth'
        })

        /* 원본 끝 */
        if (this.currentIndex >= 5) {

          setTimeout(() => {

            slider.style.scrollBehavior = 'auto'

            this.currentIndex = 0

            slider.scrollTo({
              left: 0
            })

            setTimeout(() => {
              slider.style.scrollBehavior = 'smooth'
            }, 50)

          }, 700)

        }

      }, 5000)

    },

    /* 드래그 시작 */
    startDrag(e) {

      this.isDown = true

      this.startX =
        e.pageX - this.$refs.slider.offsetLeft

      this.scrollLeft =
        this.$refs.slider.scrollLeft
    },

    /* 드래그 */
    onDrag(e) {

      if (!this.isDown) return

      e.preventDefault()

      const x =
        e.pageX - this.$refs.slider.offsetLeft

      const walk =
        (x - this.startX) * 1.5

      this.$refs.slider.scrollLeft =
        this.scrollLeft - walk
    },

    /* 드래그 종료 */
    stopDrag() {
      this.isDown = false
    }

  }

}
</script>

<style scoped>
#ndaylive_event{
  margin-top:-56px;
}

/* ---------------- main ---------------- */

.ndaylive_event_main{
  position: relative;
  width: 100%;
}

.ndaylive_event_main_img{
  width: 100%;
  display: block;
  position: relative;
  z-index: 2;
}

.ndaylive_event_main_video_div{
  position: absolute;

  top: 65.3%;
  left: 50%;

  transform: translate(-50%, -50%);

  width: 30%;

  aspect-ratio: 549 / 419;

  overflow: hidden;

  z-index: 1;

  background: #000;
}

.ndaylive_event_video{
  width: 100%;
  height: 100%;

  object-fit: fill;
}

/* ---------------- sec2 ---------------- */

.ndaylive_event_sec2{
  width: 100%;
  height: 1080px;

  margin: 0 auto;

  text-align: center;

  padding-top: 30px;

  background:
    url(../assets/img/ndaylive_event/sec2_background.png)
    no-repeat center 100%
    #fe112d;
}

.ndaylive_sec2_box{
  background-color: #fff;

  width: 638px;
  height: 240px;

  border-radius: 10px;

  margin: 30px auto 15px;

  transition: all 0.2s;

  overflow: hidden;
}

.ndaylive_sec2_box img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ndaylive_sec2_box:hover{
  transform: translateY(-10px);
}

/* ---------------- sec3 ---------------- */

.ndaylive_event_sec3{
  width: 100%;
  height: 660px;

  background: #fff;

  display: flex;
  justify-content: center;
  align-items: center;

  overflow: hidden;
}

.ndaylive_sec3_slide_wrap{
  width: 1200px;

  display: flex;
  gap: 20px;

  overflow-x: auto;
  overflow-y: hidden;

  scroll-behavior: smooth;

  cursor: grab;

  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
}

.ndaylive_sec3_slide_wrap::-webkit-scrollbar{
  display: none;
}

.ndaylive_sec3_slide_wrap:active{
  cursor: grabbing;
}

.ndaylive_sec3_box{
  min-width: calc((1200px - 40px) / 3);
  height: 500px;

  border-radius: 10px;

  overflow: hidden;

  background: #fe112d;

  flex-shrink: 0;

  position: relative;
}

.ndaylive_sec3_box img{
  width: 100%;
  height: 100%;


  display: block;
}

/* 커밍순 */
.coming_soon_overlay{
  position: absolute;
  inset: 0;

  background: rgba(0,0,0,0.55);

  display: flex;
  justify-content: center;
  align-items: center;

  color: #fff;
  font-size: 28px;
  font-weight: 700;

  letter-spacing: 2px;

  backdrop-filter: blur(2px);

  z-index: 5;
}

/* 잠금 */
.locked img{
  filter: brightness(0.6);
}

.ndaylive_event_sec4{
  background: url(../assets/img/ndaylive_event/sec4_bg.png)no-repeat center 100% #050503;
  width: 100%;
  height: 1380px;

  margin: 0 auto;

  text-align: center;

  padding-top: 30px;
}
.ndaylive_event_sec4 img{
  display:block;
  margin: 0 auto;
  transition: all 0.2s;
}
.ndaylive_event_sec4 img:hover{
  transition: all 0.2s;
  transform: translateY(-10px);
}
.ndaylive_event_sec5{
  background-color: #fe112d;
  text-align: center;
  height: 170px;
}
.ndaylive_event_sec5 a{
  display: block;
  background-color: #fff;
  color: #fe112d;
  font-weight: bold;
  margin: 0 auto;
  width: 250px;
  height: 80px;
  font-size: 1.2rem;
  border-radius: 50px;
  padding-top: 1.5rem;
    transition: all 0.2s;
}
.ndaylive_event_button{
  padding-top: 50px;
}
.ndaylive_event_sec5 a:hover{
  transition: all 0.2s;
  background-color: #610913;
  color: #fff;
}

/* ---------------- mobile ---------------- */

@media (max-width: 768px){

  /* 전체 */
  body{
    overflow-x: hidden;
  }

  html,
  body,
  #app,
  #ndaylive_event{
    width: 100%;
    overflow-x: hidden;
  }

  #ndaylive_event{
    margin-top: 4rem;
  }


  /* ---------------- main ---------------- */

  .ndaylive_event_main{
    position: relative;
    overflow: hidden;
  }

  /* 메인 이미지 더 확대 */
  .ndaylive_event_main_img{
    width: 265%;
    max-width: none;

    margin-left: -82.5%;

    display: block;
  }

  /* 영상 위치 */
  .ndaylive_event_main_video_div{
    width: 78%;

    top: 66%;
    left: 50%;

    transform: translate(-50%, -50%);
  }


  /* ---------------- line png ---------------- */

  .ndaylive_event_line_img{
    width: 265% !important;
    max-width: none !important;

    margin-left: -82.5%;

    display: block;
    position: relative;
  }


  /* ---------------- sec2 ---------------- */

  .ndaylive_event_sec2{
    height: auto;

    padding:
      20px 0 60px;

    overflow: hidden;
  }

  .ndaylive_event_sec2 > img{
    width: 85%;
  }

  .ndaylive_sec2_box{
    width: 92%;
    height: auto;

    margin:
      20px auto 0;

    border-radius: 10px;
    overflow: hidden;
  }

  /* 이미지 안늘어짐 */
  .ndaylive_sec2_box img{
    width: 100%;
    height: auto;

    display: block;
  }


  /* ---------------- sec3 ---------------- */

  .ndaylive_event_sec3{
    height: 620px;

    overflow: hidden;
  }

  .ndaylive_sec3_slide_wrap{
    width: 100%;

    gap: 12px;

    padding: 0 14px;
  }

  /* 박스 */
  .ndaylive_sec3_box{
    min-width: 66%;

    height: 500px;

    border-radius: 10px;

    overflow: hidden;

    position: relative;

    background: #000;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* 이미지 */
  .ndaylive_sec3_box img{
    width: 100%;
    height: 100%;

    object-fit: contain;

    object-position: center;

    display: block;

    background: #000;
  }

  /* 커밍순 */
  .coming_soon_overlay{
    font-size: 20px;

    line-height: 1.5;

    text-align: center;
  }


  /* ---------------- sec4 ---------------- */

  .ndaylive_event_sec4{
    height: auto;

    padding:
      30px 0 60px;

    overflow: hidden;
  }

  .ndaylive_event_sec4 > img{
    width: 92%;
  }

  .ndaylive_event_sec4 img{
    width: 92%;
    height: auto;

    display: block;
  }


  /* ---------------- sec5 ---------------- */

  .ndaylive_event_sec5{
    height: 130px;
  }

  .ndaylive_event_button{
    padding-top: 25px;
  }

  .ndaylive_event_sec5 a{
    width: 220px;
    height: 65px;

    font-size: 1rem;

    padding-top: 1rem;
  }

  .mobile_small_bsu{
    width: 80% !important;
  }
}
</style>
